import React, { useEffect, useState } from "react";
import io from "socket.io-client";
import { useHistory } from "react-router-dom";
import "./editor-page.css";

import TitleEditor from "../components/title-editor";
import Participants from "../components/participants";

import TitleState from "../components/title-state";

import participants from "../participants.json";

const placeHolderValue = "What's your meeting subject";

const initialValue = TitleState.create({
  value: "What's your meeting subject",
  source: "user",
});

const socket = io("http://127.0.0.1:3002");

socket.on("connect", () => {
  console.log("connected to server ..");
});

socket.on("connection", () => {
  console.log("connected, retreive things about this user");
});

function getSessionInfo() {
  const userInfo = window.sessionStorage.getItem("user");

  if (userInfo) {
    return JSON.parse(userInfo);
  } else {
    return null;
  }
}

export default function EditorPage() {
  const [titleState, setTitleState] = useState(initialValue);
  const [currentUser, setCurrentUser] = useState(getSessionInfo());
  const history = useHistory();

  useEffect(() => {
    if (!currentUser) {
      history.push("/");
    }

    socket.on("title-change", (data) => {
      if (data.source === "broadcast") onTitleChange(TitleState.create(data));
    });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (titleState.getSource() === "user") {
      socket.emit("title-change", titleState.toJS());
    }
    //eslint-disable-next-line
  }, [titleState]);

  const onTitleChange = (value) => setTitleState(value);

  return (
    <div className="editor">
      <div className="editor-topbar"></div>
      <div className="editor-header">
        <TitleEditor
          placeHolderValue={placeHolderValue}
          titleState={titleState}
          onTitleChange={onTitleChange}
        />
        {/*<Participants members={participants} />*/}
      </div>
    </div>
  );
}
